import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { call } from 'redux-saga/effects';
import { request } from '../../xhr/request';
function getFakeGroups(content_type, cursor) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        const groups = require('@wix/da-sample-data').groups;
        const offset = Number(cursor !== null && cursor !== void 0 ? cursor : 0);
        const pinned = groups.slice(0, 2).map((group)=>_object_spread_props(_object_spread({}, group), {
                isWatching: true,
                networkbar: {
                    isPinned: true,
                    hasNewContent: Math.random() > 0.8
                }
            }));
        const watched = groups.slice(2).map((group)=>_object_spread_props(_object_spread({}, group), {
                isWatching: true,
                networkbar: {
                    isPinned: false,
                    hasNewContent: Math.random() > 0.8
                }
            }));
        const fetchWatched = content_type !== 'recommended_groups';
        const fetchRecommended = content_type !== 'watched_groups';
        const watchedGroups = fetchWatched ? {
            groups: [
                ...pinned,
                ...watched
            ].slice(offset, offset + 5),
            hasMore: groups.length > offset + 5,
            cursor: offset + 5
        } : undefined;
        const recommendedGroups = fetchRecommended ? {
            groups: groups.slice(offset, 3).map((group, idx)=>_object_spread_props(_object_spread({}, group), {
                    userId: group.userId + 10000000
                })).map((group)=>_object_spread_props(_object_spread({}, group), {
                    isWatching: false
                })),
            hasMore: groups.length > offset + 3,
            cursor: offset + 3
        } : undefined;
        return {
            mainNavNewItem: [
                'dyw'
            ],
            watchedGroups,
            recommendedGroups
        };
    }
    return {};
}
export function* fetchGroups(content_type, cursor) {
    const result = yield call(request, {
        method: 'get',
        url: '/networkbar',
        params: {
            cursor,
            content_type,
            expand: 'user.networkbar,user.watch'
        }
    }, ()=>getFakeGroups(content_type, cursor));
    return result;
}
export function* doPinGroup(userid) {
    const result = yield call(request, {
        method: 'post',
        url: '/networkbar/pingroup',
        data: {
            userid
        }
    }, ()=>({
            success: true
        }));
    return result;
}
export function* doUnpinGroup(userid) {
    const result = yield call(request, {
        method: 'post',
        url: '/networkbar/unpingroup',
        data: {
            userid
        }
    }, ()=>({
            success: true
        }));
    return result;
}
export function* doUnrecommendGroup(userid) {
    const result = yield call(request, {
        method: 'post',
        url: '/networkbar/unrecommendgroup',
        data: {
            userid
        }
    }, ()=>({
            success: true
        }));
    return result;
}
export function* doToggleSection(section, isFoldedNow) {
    const data = {
        content_type: section,
        is_collapsed: isFoldedNow
    };
    const result = yield call(request, {
        method: 'post',
        url: '/networkbar/update_section',
        data
    }, ()=>({
            success: true
        }));
    return result;
}
